module.exports = __webpack_public_path__ + "assets/manual_assuranceHome-8978b94fd5a360357f8b4f9c3669a8a6.pdf";